import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function PatientDirectorySkeleton() {
  return (
    <div className="parentContainer">
      <div className="mainContainer">
        {/* TitleBar Skeleton */}
        <div style={{ marginBottom: "24px" }}>
          <Skeleton height={40} width={280} style={{ marginBottom: "8px" }} />
        </div>

        {/* Search Bar Skeleton */}
        <div style={{ marginBottom: "24px" }}>
          <Skeleton height={48} width="100%" />
        </div>

        {/* Patient Cards/Table Skeleton */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: "16px" }}>
          {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
            <div key={i}>
              <Skeleton height={120} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PatientDirectorySkeleton;
